import { useQuery } from "react-query";
import { getCloudinaryMediaUrl } from "shared-services";
import {
  authAxios as axios,
  getUserAttribute,
  UserAttributes,
} from "shared-auth";
import { config } from "../../../../config";

export const cloudinaryAvatarParams = "c_thumb,g_face,h_150,w_150";

export const queryMainPhotoQueryLey = "get-performer-main-photo";

export function useGetAvatar() {
  const sub = getUserAttribute(UserAttributes.MasterPortalGuid);

  const { data: imgKey = "" } = useQuery<string>(
    [queryMainPhotoQueryLey, sub],
    async () => {
      const { data } = await axios.get(
        `${config.profileApiUrl}/profiles/${sub}/mainphoto`
      );

      return data?.url;
    },
    { enabled: !!sub }
  );

  if (imgKey) return getCloudinaryMediaUrl(imgKey, cloudinaryAvatarParams);
}
